import { useQuery } from '..';
import permissions from '../Apollo/permissions';
import { QUERY_WEBHOOK_EVENT_TYPES } from './query-webhook-event-types-builder';

export default function useQueryWebhookEventTypes(options = {}) {
  const { data, loading, error, isAllowed } = useQuery(QUERY_WEBHOOK_EVENT_TYPES, {
    context: { permission: permissions.readWebhookConfig },
    ...options,
  });
  const eventTypes = Array.isArray(data?.webhookEventTypes) ? data.webhookEventTypes : [];

  return { eventTypes, loading, error, isAllowed };
}
